export default __webpack_public_path__ + "static/media/cu.36e215a7.svg";